import { HoverTaskType } from "../../../types/ganttChart";
import hoverBoxStyle from "../../../styles/hover.module.css";
import timelineService from "../../../service/timelineService";

const HoverDurationBox = ({
  type,
  duration,
}: {
  type: HoverTaskType;
  duration: string;
}) => {
  const getBackgroundColor = () => {
    switch (type) {
      case "WORKTASK":
        return "var(--col-success-primary)";
      case "TRANSPORTATION_TASK":
        return "var(--col-graph-first-1)";
      case "OPERATIONAL":
        return "var(--col-warning-primary)";
    }
  };

  return (
    <div
      className={hoverBoxStyle.duration}
      style={{ backgroundColor: getBackgroundColor() }}
    >
      {timelineService.returnDurationInMinutes(duration)}
    </div>
  );
};

export default HoverDurationBox;
